(function () {
  'use strict';

  if (window.__snSearchV49) return;
  window.__snSearchV49 = true;

  var PRODUCT_KEY = 'sn_recent_products_v2';
  var SEARCH_KEY = 'sn_search_history_v2';
  var MAX_PRODUCTS = 4;
  var MAX_SEARCHES = 6;
  var pageLocked = false;

  function readStore(key) {
    try {
      var value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function writeStore(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (error) {}
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function normalize(value) {
    return cleanText(value).toLocaleLowerCase('sv-SE').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function cleanProductUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return '';
      url.search = '';
      url.hash = '';
      return url.pathname;
    } catch (error) {
      return '';
    }
  }

  function saveRecentProduct(link) {
    var url = cleanProductUrl(link.getAttribute('href'));
    var title = cleanText(link.dataset.snProductTitle || link.textContent);
    var image = cleanText(link.dataset.snProductImage || '');
    if (!url || !title) return;
    var products = readStore(PRODUCT_KEY).filter(function (item) { return item && item.url !== url; });
    products.unshift({ title: title, url: url, image: image });
    writeStore(PRODUCT_KEY, products.slice(0, MAX_PRODUCTS));
  }

  function saveSearch(value) {
    var query = cleanText(value);
    if (query.length < 2) return;
    var normalizedQuery = normalize(query);
    var searches = readStore(SEARCH_KEY).filter(function (item) { return normalize(item) !== normalizedQuery; });
    searches.unshift(query);
    writeStore(SEARCH_KEY, searches.slice(0, MAX_SEARCHES));
  }

  function productCard(item) {
    var link = document.createElement('a');
    link.className = 'sn-search-history-product';
    link.href = item.url;
    link.dataset.snSearchProduct = '';
    link.dataset.snProductTitle = item.title;
    link.dataset.snProductImage = item.image || '';
    if (item.image) {
      var image = document.createElement('img');
      image.src = item.image;
      image.alt = '';
      image.width = 88;
      image.height = 88;
      image.loading = 'lazy';
      link.appendChild(image);
    }
    var title = document.createElement('span');
    title.textContent = item.title;
    link.appendChild(title);
    return link;
  }

  function renderRecentProducts(root) {
    var section = root.querySelector('[data-sn-recent-products]');
    var list = root.querySelector('[data-sn-recent-products-list]');
    if (!section || !list) return false;
    var products = readStore(PRODUCT_KEY).filter(function (item) {
      return item && item.url && item.title;
    }).slice(0, MAX_PRODUCTS);
    list.replaceChildren();
    products.forEach(function (item) { list.appendChild(productCard(item)); });
    section.hidden = products.length === 0;
    return products.length > 0;
  }

  function renderSearchHistory(root) {
    var section = root.querySelector('[data-sn-search-history]');
    var list = root.querySelector('[data-sn-search-history-list]');
    if (!section || !list) return false;
    var searches = readStore(SEARCH_KEY).slice(0, MAX_SEARCHES);
    list.replaceChildren();
    searches.forEach(function (query) {
      var link = document.createElement('a');
      link.className = 'sn-search-history-chip';
      link.href = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
      link.textContent = query;
      link.addEventListener('click', function () { saveSearch(query); });
      list.appendChild(link);
    });
    section.hidden = searches.length === 0;
    return searches.length > 0;
  }

  function renderSearchPageHistory() {
    document.querySelectorAll('[data-sn-search-page-history]').forEach(function (section) {
      var list = section.querySelector('[data-sn-search-page-history-list]');
      if (!list) return;
      var searches = readStore(SEARCH_KEY).slice(0, MAX_SEARCHES);
      list.replaceChildren();
      searches.forEach(function (query) {
        var link = document.createElement('a');
        link.href = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
        link.textContent = query;
        list.appendChild(link);
      });
      section.hidden = searches.length === 0;
    });
  }

  function renderEmptyState(root) {
    var hasRecentProducts = renderRecentProducts(root);
    var hasSearchHistory = renderSearchHistory(root);
    root.classList.toggle('sn-search-idle-empty', !hasRecentProducts && !hasSearchHistory && !root.getQuery());
    var empty = root.querySelector('[data-sn-search-empty]');
    if (empty) empty.hidden = false;
    var results = root.querySelector('.search__results');
    if (results) results.style.display = 'none';
  }

  function hideEmptyState(root) {
    root.classList.remove('sn-search-idle-empty');
    var empty = root.querySelector('[data-sn-search-empty]');
    if (empty) empty.hidden = true;
    var results = root.querySelector('.search__results');
    if (results) results.style.removeProperty('display');
  }

  function preventBackgroundTouch(event) {
    if (!pageLocked) return;
    var scrollArea = event.target.closest && event.target.closest('.sn-search .search__content');
    if (!scrollArea) event.preventDefault();
  }

  function lockPage() {
    if (pageLocked || window.innerWidth >= 990) return;
    pageLocked = true;
    document.documentElement.classList.add('sn-search-scroll-locked');
    document.body.classList.add('sn-search-scroll-locked');
    document.addEventListener('touchmove', preventBackgroundTouch, { passive: false });
  }

  function unlockPage() {
    if (!pageLocked) return;
    pageLocked = false;
    document.documentElement.classList.remove('sn-search-scroll-locked');
    document.body.classList.remove('sn-search-scroll-locked');
    document.removeEventListener('touchmove', preventBackgroundTouch, false);
  }

  function scoreTitle(title, query) {
    var normalizedTitle = normalize(title);
    var normalizedQuery = normalize(query);
    var words = normalizedQuery.split(' ').filter(Boolean);
    var titleWords = normalizedTitle.split(' ');
    var score = 0;
    if (normalizedTitle === normalizedQuery) score += 10000;
    if (normalizedTitle.indexOf(normalizedQuery) === 0) score += 6000;
    if (normalizedTitle.indexOf(normalizedQuery) !== -1) score += 3000;
    words.forEach(function (word, index) {
      if (titleWords[index] && titleWords[index].indexOf(word) === 0) score += 1200;
      else if (titleWords.some(function (part) { return part.indexOf(word) === 0; })) score += 700;
      else if (normalizedTitle.indexOf(word) !== -1) score += 300;
    });
    return score;
  }

  function rankResults(container, query) {
    var grid = container.querySelector('[data-sn-result-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-sn-result-card]'));
    cards.map(function (card, index) {
      return { card: card, index: index, score: scoreTitle(card.dataset.snTitle || '', query) };
    }).sort(function (a, b) {
      return b.score - a.score || a.index - b.index;
    }).forEach(function (item) { grid.appendChild(item.card); });
  }

  function highlightResults(container, query) {
    var text = cleanText(query);
    if (!text) return;
    // Match each search word at a word boundary, including unfinished words.
    // "n one l" highlights N, One and L in "N One Crystal Liquorice".
    var words = text.split(/\s+/).filter(Boolean);
    var terms = [text].concat(words).filter(function (term, index, all) {
      return all.indexOf(term) === index;
    }).sort(function (a, b) { return b.length - a.length; });
    var escaped = terms.map(function (term) {
      return term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }).join('|');
    var matcher = new RegExp('(?<![\\p{L}\\p{N}_])(' + escaped + ')', 'giu');
    container.querySelectorAll('.sn-search-result-title, .sn-search-collection').forEach(function (title) {
      var value = title.textContent || '';
      var parts = value.split(matcher);
      if (parts.length < 2) return;
      // One inline context preserves spaces around the highlighted words.
      var label = document.createElement('span');
      label.style.display = 'inline-block';
      title.replaceChildren(label);
      parts.forEach(function (part, index) {
        if (!part) return;
        if (index % 2 === 1) {
          var mark = document.createElement('mark');
          mark.className = 'sn-search-match';
          mark.textContent = part;
          label.appendChild(mark);
        } else {
          label.appendChild(document.createTextNode(part));
        }
      });
    });
  }

  function formatSearchVariantPrices(container) {
    container.querySelectorAll('select[data-sn-select] option').forEach(function (option) {
      var pack = /^(\d+)\s*(?:-\s*p|pack)\b/i.exec(option.dataset.title || '');
      var cents = Number(option.dataset.price);
      if (!pack || !option.dataset.price || !Number.isFinite(cents) || cents < 0) return;
      var quantity = Number(pack[1]);
      if (quantity < 1) return;
      var unitPrice = (Math.round(cents / quantity) / 100).toFixed(2).replace('.', ',');
      // Preserve the label and total price; normalize only the unit price.
      option.textContent = option.textContent.replace(/\([\d\s.,]+\s*kr\s*\/\s*st\)/i, '(' + unitPrice + ' kr/st)');
    });
  }

  function syncFeatured(search) {
    formatSearchVariantPrices(search);
    var featured = search.querySelector('[data-sn-featured]');
    if (featured) featured.hidden = search.getQuery().length < 1;
  }

  function openSearch(search) {
    syncFeatured(search);
    search.searchContent && search.searchContent.classList.remove('hidden');
    search.classList.add('predictive-search-open');
    search.setAttribute('results', 'true');
    document.body.classList.add('search-open');
    lockPage();
  }

  function closeSearch(search) {
    search.__snDismissed = true;
    ++search.__snRequestNumber;
    if (search.__snController) search.__snController.abort();
    if (typeof search.toggleSearchState === 'function') search.toggleSearchState(false);
    search.classList.remove('predictive-search-open');
    search.removeAttribute('results');
    search.removeAttribute('loading');
    if (search.searchContent) search.searchContent.classList.add('hidden');
    search.input.setAttribute('aria-expanded', 'false');
    if (document.activeElement && search.contains(document.activeElement)) document.activeElement.blur();
    if (!document.querySelector('predictive-search.predictive-search-open')) {
      document.body.classList.remove('search-open');
      unlockPage();
    }
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('predictive-search.predictive-search-open').forEach(function (search) {
      if (!search.contains(event.target)) closeSearch(search);
    });
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('predictive-search.predictive-search-open').forEach(closeSearch);
  });

  function filterHiddenCollections(search, target) {
    var names;
    try { names = JSON.parse(search.dataset.snHiddenNames || 'null'); }
    catch (error) { names = null; }
    if (names == null) names = 'British American Tobacco\nSkruf Snus AB';
    function normalizeName(value) {
      return String(value || '').normalize('NFKC').toLocaleLowerCase('sv-SE').replace(/\s+/g, ' ').trim();
    }
    var hidden = new Set(String(names).split(/\r?\n|\r|\|/).map(normalizeName).filter(Boolean));
    target.querySelectorAll('.sn-search-collections').forEach(function (group) {
      group.querySelectorAll('.sn-search-collection').forEach(function (link) {
        if (hidden.has(normalizeName(link.textContent))) link.remove();
      });
      if (!group.querySelector('.sn-search-collection')) {
        var section = group.closest('.sn-search-section');
        if (section) {
          var divider = section.nextElementSibling;
          if (divider && divider.classList.contains('sn-search-divider')) divider.remove();
          section.remove();
        }
      }
    });
  }

  function patchPredictiveSearch(search) {
    if (!search || search.__snSearchV49Ready) return;
    search.__snSearchV49Ready = true;
    search.__snDismissed = false;
    search.__snRequestNumber = 0;
    search.__snController = null;
    formatSearchVariantPrices(search);

    var searchButton = search.querySelector('.sn-search-submit');
    if (searchButton) {
      searchButton.addEventListener('click', function (event) {
        event.preventDefault();
        search.__snDismissed = false;
        if (search.getQuery()) hideEmptyState(search);
        else renderEmptyState(search);
        openSearch(search);
        try { search.input.focus({ preventScroll: true }); }
        catch (error) { search.input.focus(); }
      });
    }

    search.setupURL = function () {
      var base = window.FoxTheme && FoxTheme.routes ? FoxTheme.routes.predictive_search_url : '/search/suggest';
      var url = new URL(base, window.location.origin);
      url.searchParams.set('q', this.getQuery());
      url.searchParams.set('resources[type]', 'product,collection');
      url.searchParams.set('resources[limit]', '10');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][prefix]', 'last');
      url.searchParams.set('resources[options][unavailable_products]', 'show');
      url.searchParams.set('section_id', this.dataset.snSectionId || FoxTheme.utils.getSectionId(this));
      return url;
    };

    search.renderSectionFromFetch = function (url) {
      if (this.__snDismissed) return;
      var self = this;
      var requestNumber = ++this.__snRequestNumber;
      if (this.__snController) this.__snController.abort();
      this.__snController = 'AbortController' in window ? new AbortController() : null;
      this.setLoadingState(true);
      fetch(url, this.__snController ? { signal: this.__snController.signal } : undefined)
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.text();
        })
        .then(function (responseText) {
          if (requestNumber !== self.__snRequestNumber) return;
          self.cachedMap.set(url, responseText);
          self.renderSearchResults(responseText);
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') console.error('Sökningen kunde inte laddas:', error);
        })
        .finally(function () {
          if (requestNumber === self.__snRequestNumber) self.setLoadingState(false);
        });
    };

    search.renderSearchResults = function (responseText) {
      if (this.__snDismissed) return;
      var id = 'PredictiveSearchResults-' + (this.dataset.snSectionId || FoxTheme.utils.getSectionId(this));
      var target = document.getElementById(id);
      if (!target) return;
      var parsed = new DOMParser().parseFromString(responseText, 'text/html');
      var source = parsed.getElementById(id);
      if (!source) return;
      target.innerHTML = source.innerHTML;
      filterHiddenCollections(this, target);
      rankResults(target, this.getQuery());
      highlightResults(target, this.getQuery());
      formatSearchVariantPrices(target);
      if (window.__snBindCards) window.__snBindCards(target);
      hideEmptyState(this);
      openSearch(this);
      this.removeAttribute('loading');
      this.resetButton && this.resetButton.classList.remove('btn--loading');
      this.input.setAttribute('aria-expanded', 'true');
    };

    search.input.addEventListener('pointerdown', function () {
      search.__snTapScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    }, true);
    search.input.addEventListener('touchstart', function () {
      if (typeof search.__snTapScrollY !== 'number') {
        search.__snTapScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      }
    }, { capture: true, passive: true });
    search.input.addEventListener('focus', function () {
      var tapScrollY = search.__snTapScrollY;
      search.__snTapScrollY = null;
      search.__snDismissed = false;
      if (!search.getQuery()) renderEmptyState(search);
      openSearch(search);
      if (typeof tapScrollY === 'number') {
        var restoreTappedScroll = function () {
          if (Math.abs((window.scrollY || 0) - tapScrollY) > 1) window.scrollTo(0, tapScrollY);
        };
        window.requestAnimationFrame(restoreTappedScroll);
        window.setTimeout(restoreTappedScroll, 120);
      }
    }, true);
    search.input.addEventListener('input', function () {
      search.__snDismissed = false;
      syncFeatured(search);
      if (search.getQuery()) hideEmptyState(search);
      else renderEmptyState(search);
    });
    if (search.resetButton) {
      search.resetButton.addEventListener('click', function () {
        window.setTimeout(function () { renderEmptyState(search); openSearch(search); }, 0);
      });
    }
    renderRecentProducts(search);
    renderSearchHistory(search);
  }

  function patchAllSearches() {
    document.querySelectorAll('predictive-search').forEach(patchPredictiveSearch);
  }

  function prefetchProduct(link) {
    if (!link || link.dataset.snPrefetched === 'true') return;
    if (navigator.connection && navigator.connection.saveData) return;
    var href = cleanProductUrl(link.href);
    if (!href) return;
    link.dataset.snPrefetched = 'true';
    var preload = document.createElement('link');
    preload.rel = 'prefetch';
    preload.href = href;
    document.head.appendChild(preload);
  }

  document.addEventListener('pointerenter', function (event) {
    var link = event.target.closest && event.target.closest('a[data-sn-search-product]');
    if (link) prefetchProduct(link);
  }, true);

  document.addEventListener('click', function (event) {
    var product = event.target.closest && event.target.closest('a[data-sn-search-product]');
    if (product) saveRecentProduct(product);
    var clearProducts = event.target.closest && event.target.closest('[data-sn-clear-products]');
    if (clearProducts) {
      event.preventDefault();
      writeStore(PRODUCT_KEY, []);
      document.querySelectorAll('predictive-search').forEach(function (search) {
        if (!search.getQuery()) renderEmptyState(search);
        else renderRecentProducts(search);
      });
    }
    var clearSearches = event.target.closest && event.target.closest('[data-sn-clear-searches]');
    if (clearSearches) {
      event.preventDefault();
      writeStore(SEARCH_KEY, []);
      document.querySelectorAll('predictive-search').forEach(function (search) {
        if (!search.getQuery()) renderEmptyState(search);
        else renderSearchHistory(search);
      });
      renderSearchPageHistory();
    }
  });

  document.addEventListener('submit', function (event) {
    var input = event.target.querySelector && event.target.querySelector('input[type="search"][name="q"]');
    if (input) saveSearch(input.value);
  });

  var bodyObserver = new MutationObserver(function () {
    if (!document.body.classList.contains('search-open')) unlockPage();
  });

  function init() {
    patchAllSearches();
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var params = new URLSearchParams(window.location.search);
    if (window.location.pathname.indexOf('/search') !== -1) saveSearch(params.get('q') || '');
    renderSearchPageHistory();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', patchAllSearches);
  window.addEventListener('pageshow', function () { unlockPage(); patchAllSearches(); renderSearchPageHistory(); });
})();
